import { Observable } from 'rxjs';
import { Progress } from 'shared/framework/data-access/angular';
import { TemporaryFile } from '../../models/temporary-file/temporary-file.model';

export abstract class AbstractTemporaryFileService {
    abstract uploadTemporaryFile: (
        file: File,
    ) => Observable<Progress<TemporaryFile>>;
}
